import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Megaphone } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Flash.css';

const config = require('../../../config.json');

const defaultAnnouncements = [
  /*  { message: "Admissions Open 2026–2027: Applications invited for B.Th., M.Th. (STL) & Doctoral (D.Th.) programmes.", link: "/admission/details", tag: "Admissions" },
    { message: "Vidyajyoti Central Library: Over 1,34,000 cataloged volumes & 228 journals open for research scholars.", link: "/library/about", tag: "Library" },
    { message: "VJ-DEPTh Distance Education in Theology: Registrations open for Catholic Laity worldwide (www.vjdepth.in).", link: "/academics/depth", tag: "VJ-DEPTh" },
    { message: "Vidyajyoti Journal of Theological Reflection: Monthly research issues & archives accessible.", link: "/publications/vj-journal", tag: "Publications" },
    { message: "Academic Year 2026–2027 Commencement: Classes commence on Monday, 06 July 2026.", link: "/admission/details", tag: "Academic" }*/
];

export default function FlashNewsMarque() {
  const [activePost, setActivePost] = useState([]);

  useEffect(() => {
    fetchActiveInfo();
  }, []);

  const generateDate = async () => {
    const d = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const fetchActiveInfo = async () => {
    try {
      const startDate = await generateDate();
      const clientID = "VJCollege";
      const searchOption = "Flash News";

      const response = await axios.get(
        `${config.api.invokeURL}/dashboard/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}`,
        {
          headers: {
            'x-api-key': config.api.key
          }
        }
      );

      if (response.data && response.data.length > 0) {
        setActivePost(response.data);
      } /*else {
        setActivePost(defaultAnnouncements);
      }*/
    } catch (error) {
      console.warn("Using fallback institutional announcements for flash news ticker.");
      setActivePost(defaultAnnouncements);
    }
  };

  const newsList = activePost && activePost.length > 0 ? activePost : defaultAnnouncements;

  return (
    <div className="vj-ticker-bar">
      {/* Live Badge with Pulsing Beacon */}
      <div className="vj-ticker-badge">
        <span className="vj-live-beacon"></span>
        <Megaphone size={15} />
        <span>Updates</span>
      </div>

      {/* Infinite Smooth Scrolling Track */}
      <div className="vj-ticker-container">
        <div className="vj-marquee-track">
          {newsList.map((item, index) => {
            const msg = item.flashNews?.message || item.message || '';
            const tag = item.tag || 'Notice';
            const link = item.link;

            const content = (
              <>
                <span className="vj-ticker-tag">{tag}</span>
                <span>{msg}</span>
                <span className="vj-ticker-bullet">★</span>
              </>
            );

            return link ? (
              <Link to={link} className="vj-ticker-item" key={`news-1-${index}`}>
                {content}
              </Link>
            ) : (
              <div className="vj-ticker-item" key={`news-1-${index}`}>
                {content}
              </div>
            );
          })}

          {/* Duplicated track for smooth infinite scroll */}
          {newsList.map((item, index) => {
            const msg = item.flashNews?.message || item.message || '';
            const tag = item.tag || 'Notice';
            const link = item.link;

            const content = (
              <>
                <span className="vj-ticker-tag">{tag}</span>
                <span>{msg}</span>
                <span className="vj-ticker-bullet">★</span>
              </>
            );

            return link ? (
              <Link to={link} className="vj-ticker-item" key={`news-2-${index}`}>
                {content}
              </Link>
            ) : (
              <div className="vj-ticker-item" key={`news-2-${index}`}>
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
